import { HTTP_CP_Company, HTTP_CP_CompanySettings } from '@api-new/companyservice';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { CompanyState } from '@shared/store/company/company.state';

export const selectCompanyState = createFeatureSelector<CompanyState>('company');

export const selectCompany = createSelector(selectCompanyState, (state: CompanyState): HTTP_CP_Company | null => state.company || null);

export const selectCompanyNetworkId = createSelector(
  selectCompanyState,
  (state: CompanyState): string | null => state.company?.networkId || null,
);

export const selectIsLoadingCompany = createSelector(selectCompanyState, (state: CompanyState): boolean => state.loading);

export const selectCompanyLogo = createSelector(selectCompany, (company: HTTP_CP_Company): string | null => company?.logo || null);

export const selectCompanyTradingName = createSelector(
  selectCompany,
  (company: HTTP_CP_Company): string | null => company?.tradingName || null,
);

export const selectCompanySettings = createSelector(selectCompany, (company) => company?.companySettings);

export const selectCompanyShowAdvisorPage = createSelector(
  selectCompanySettings,
  (companySettings: HTTP_CP_CompanySettings): boolean => companySettings?.showAdvisorPage,
);

export const selectCanAccessSmartSearch = createSelector(selectCompanySettings, (companySettings) => companySettings?.showSmartSearch);
